import React from 'react';
import PropTypes from 'prop-types';
import './scopeBE.scss';

const RadioButtonGroup = ({ options, value, name, onChange }) => {
  return (
    <div
      className="radio-button-group"
    >
      {options.map((option) => (
        <div key={option.value} style={{ marginBottom: '8px' }}>
          <label>
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={onChange}
              style={{ marginRight: '8px' }}
            />
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
};

// PropTypes validation
RadioButtonGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })).isRequired,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RadioButtonGroup;
